export const GLOBAL_FIELDS_CHANNEL = 'jpd.global-fields';
